export default __webpack_public_path__ + "static/africaCupOfNationsFlag-4f291477f434d51cba47e052c054eff2.svg";